import config from '@/config'

export const saveLensToStorage = (id, side) => {
  const expiry = Date.now() + 30 * 60 * 1000 // 30 minutes expiry time
  const data = {
    id,
    expiry
  }
  localStorage.setItem(`lastLens${side || 'Mobile'}`, JSON.stringify(data))
}

export const getStoredLens = side => {
  const key = side ? `lastLens${side}` : 'lastLensMobile'
  const stored = localStorage.getItem(key)
  if (stored) {
    const { id, expiry } = JSON.parse(stored)
    if (expiry > Date.now()) {
      return id
    }
    localStorage.removeItem(key) // Clean up expired entry
  }
  return null
}

export const getDefaultLens = (side, lensData) => {
  // 1. First check localStorage
  const storedLens = getStoredLens(side)
  if (storedLens) {
    return storedLens
  }

  // 2. Then check for default flags in data
  if (lensData && Array.isArray(lensData)) {
    let defaultLensName = ''
    lensData.forEach(category => {
      category.lenses.forEach(lens => {
        if (!defaultLensName) {
          if (!side && lens.defaultLeft) {
            defaultLensName = lens.name
          } else if (side === 'Left' && lens.defaultLeft) {
            defaultLensName = lens.name
          } else if (side === 'Right' && lens.defaultRight) {
            defaultLensName = lens.name
          }
        }
      })
    })

    if (defaultLensName) {
      const baseName = defaultLensName.toLowerCase().replace(/\s+/g, '-')
      if (!side) return baseName

      return `${baseName}-${side.toLowerCase()}`
    }
  }

  // 3. Finally, fallback to environment variables
  if (!side) {
    return config.mobileDefaultVideoId
  }
  return side === 'Left' ? config.webDefaultLeftVideoId : config.webDefaultRightVideoId
}

export const fallbackLens = (side, lensData) => {
  // following the structure of lensData -> has category array and lenses property has the individual lens
  const firstLens = lensData[0].lenses[0]
  const lensId = firstLens.name.toLowerCase().replace(/\s+/g, '-')

  // For mobile view, don't append side
  if (!side) {
    return lensId
  }

  // For desktop view, append side (eg: atlas-orion-left)
  return `${lensId}-${side.toLowerCase()}`
}

export const findSceneAnchorName = (anchor, storeData) => {
  if (!anchor) return null
  // Remove '-left' or '-right', replace hyphens with spaces, capitalize each word
  const anchorName = anchor.replace(/-(left|right)$/, '').toUpperCase()
  for (const category of storeData) {
    if (category.lenses && Array.isArray(category.lenses)) {
      const found = category.lenses.find(
        lens => lens.name.replace(/\s+/g, '-').toUpperCase() === anchorName
      )
      if (found) return found.name
    }
  }
  return null
}
